export const AuthRoutes = {
    Login: 'login',
    SignUp: 'signup',
    PasswordRecovery: 'reset-password',
};
